<template>
  <section
    v-if="galleryHighlight"
    class="gallery-highlight"
    :class="{ 'gallery-highlight--show': galleryShow }">
    <ul
      class="gallery-items">
      <li
        v-for="(item, key) in galleryItems"
        class="item"
        :key="`item${key}`"
        :class="[{'item--captions': item.caption !== '', 'item--active': key === galleryActive }, 'item--' + item.width]">
        <p
          v-if="item.caption !== ''"
          v-html="item.caption"></p>
        <img
          :src="item.image.url"
          @click="highlight(item)" />
      </li>
    </ul>
    <div
      v-if="galleryItems.length > 1"
      class="gallery-highlight__controls">
      <button
        class="prev"
        @click="prevItem()"></button>
      <button
        class="next"
        @click="nextItem()"></button>
    </div>
    <p
      v-if="galleryItems.length > 1"
      class="gallery-highlight__index"
      v-html="`${galleryActive + 1} / ${galleryItems.length}`"></p>
    <button
      class="gallery-highlight__close"
      @click="galleryClose()">
      Close
    </button>
  </section>
</template>

<script>
export default {
  name: 'GalleryHighlight',
  data() {
    return {
      galleryHighlight: false,
      galleryShow: false,
      galleryActive: 0,
      galleryItems: false
    }
  },
  created() {
    this.$root.$on('galleryHighlight', (items, index) => {
      this.galleryHighlight = true
      this.galleryActive = index

      if (items) {
        this.galleryItems = items

        setTimeout(() => {
          this.galleryShow = true
        }, 400)
      }
    })
  },
  methods: {
    galleryClose() {
      this.galleryShow = false

      setTimeout(() => {
        this.galleryItems = null
        this.galleryHighlight = false
      }, 400)
    },
    prevItem() {
      if (this.galleryActive > 0) this.galleryActive--

      if (this.galleryActive === 0) this.galleryActive = this.galleryItems.length - 1
    },
    nextItem() {
      if (this.galleryActive < this.galleryItems.length - 1) this.galleryActive++

      if (this.galleryActive === this.galleryItems.length - 1) this.galleryActive = 0
    }
  }
}
</script>

<style lang="scss">
.gallery-highlight {
  position:fixed;
  top:0;
  left: 50%;
  width:100%;
  height:100%;
  // max-width: $content-width;
  max-width: 100%;
  margin: 0 auto;
  transform: translateX(-50%);
  background-color: $yellow;
  z-index:10;
  padding: $page-padding;
  transition: opacity 300ms ease-in-out;
  display:flex;
  flex-direction: column;
  justify-content: space-between;

  &--show {
    opacity:1;
    transform: translateX(-50%) translateZ(1);
  }

  &__close {
    @include button_resets;
    cursor:pointer;
    font-size: 0;
    position: absolute;
    width: 45px;
    height: 45px;
    right: $page-padding;
    transition: transform 200ms ease;
    z-index: 1000;
    margin: -3px 0 0 -1px;

    &:hover {
      transform:rotate(-90deg);
    }

    &:before {
      content:'';
      display:block;
      width:80%;
      height:3px;
      background-color:#000;
      position:absolute;
      top:50%;
      left:50%;
      transform: translate(-50%, -50%) rotate(-45deg);
    }

    &:after {
      content:'';
      display:block;
      width:80%;
      height:3px;
      background-color:#000;
      position:absolute;
      top:50%;
      left:50%;
      transform: translate(-50%, -50%) rotate(45deg);
    }
  }

  .gallery-items {
    display: flex;
    flex-direction: column;
    height: 100%;

    .item {
      display:none;

      &--active {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
      }

      p {
        margin: 0 0 $padding 0;
      }

      img {
        max-height: calc(100vh - #{$padding * 4});
        object-fit: contain;
        object-position: 50% 50%;
        flex-grow: 1;
        padding-bottom: $padding;
      }
    }

  }

  &__controls {
    width: 100%;
    height: 100%;
    z-index: 1;
    position: absolute;
    cursor: none;
    button {
      @include button_resets;
      width: 50%;
      height: 100%;
      cursor:none;
      // background:green;
      &:after {
        width: 80px;
        height: 20px;
        transform: translate(-50%, -50%);
      }

      &.prev {
        cursor:w-resize;
      }
      &.next {
        cursor:e-resize;
      }
    }
  }

  &__index {
    position: absolute;
    bottom: 0.625rem;
    right: calc(0.625rem + 0px + 0px);
    margin: 0;
  }

  @media screen and (max-width: $mobile) {
    width: 100%;
    padding: $mobile-padding;

      .gallery-items {
        p {
          padding: 0 2.5rem 0 0;
        }
      }

    &__index {
      right: $mobile-padding;
    }

    &__close {
      width: 36px;
      height: 36px;
      right: $mobile-padding;
      &:before, &:after {
        height: 2px;
      }
    }
  }
}
</style>
